import { render, staticRenderFns } from "./CoreNav.vue?vue&type=template&id=7f8d2cec&scoped=true&"
import script from "./CoreNav.vue?vue&type=script&lang=js&"
export * from "./CoreNav.vue?vue&type=script&lang=js&"
import style0 from "./CoreNav.vue?vue&type=style&index=0&id=7f8d2cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8d2cec",
  null
  
)

export default component.exports